import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { MobileSecurityCompanyRecord } from '../../mobileSecurityCompanyGrid/types';

export class MobileSecurityCustomerViewDataProvider extends BaseWebComponentDataProvider {
  public async getCompany(): Promise<MobileSecurityCompanyRecord | undefined> {
    const res = await this.dependencies.api.clients.Company.getCompaniesWithMobileSecurity({}).toPromise();
    return sanitizeObject(res['data'].pop());
  }
}
